module.exports = __webpack_public_path__ + "img/indu_15.364e944b.png";